/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export const mergeFilterValues = (current: unknown, next: unknown): unknown => {
    if (Array.isArray(current) && Array.isArray(next)) {
        return Array.from(new Set([...current, ...next]))
    }

    return next
}